import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik"
import Select from "react-select";
import { dictionaryCRUD } from "../../../../actions/dictionary"

export const Residential = (props) => {

  const {data, next, back, step2, setStep2, setStep1, step1, schema} = props

  const [head, setHead] = useState([])

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryData(50, 0, '', 5).then((resp) => {
        setHead(resp.data.results)
      }).finally(() => {})
    }, 500)
  }, [])

  // Helper function to find selected option from list
  const findSelectedOption = (list, value) => {
    if (!value || !list || list.length === 0) return null;
    const item = list.find(dt => dt.id === value || dt.id === parseInt(value));
    return item ? { value: item.id, label: item.dictionary_item_name_en } : null;
  };

  const handleSubmite = (values) => {
    next(values, false)
    setStep2(!step2)
  }

  const handlePrev = (values) => {
    back(values)
    setStep1(!step1)
  }

  return (
    <>
      <Formik
        initialValues={data}
        onSubmit={handleSubmite}
        validationSchema={schema}
        enableReinitialize={true}
      >
      {({setFieldValue, values}) => (
        <Form>
          <div className={step2 ? "tab-pane fade" : !step1 ? "tab-pane fade" : "tab-pane fade show active"} id="step-identity-info" role="tabpanel" aria-labelledby="step-identity-tab">
            <div>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="relation_to_head" className="form-label">Relation to Head <span className="text-danger">*</span></label>
                    <Select
                      options={
                        head?.map((dt) => (
                          {value : dt.id, label : dt.dictionary_item_name_en}
                        ))
                      }
                      value={findSelectedOption(head, values.dictionary_relation_to_head)}
                      placeholder="Select relationship"
                      onChange={(e) => setFieldValue('dictionary_relation_to_head', e.value)}
                      isSearchable={true}
                      name='dictionary_relation_to_head'
                    />
                    <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                      <span role='alert' className='text-danger'><ErrorMessage name='dictionary_relation_to_head' /></span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="birth_certificate_no" className="form-label">Birth Certificate Number</label>
                    <Field type={'text'} className="form-control" placeholder="Birth Certificate Number" name="birth_certificate_no"/>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="zan_id_no" className="form-label">Zanzibar ID</label>
                    <Field type={'text'} className="form-control" placeholder="Zanzibar ID Number" name="zan_id_no"/>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="nida_no" className="form-label">National ID (NIDA)</label>
                    <Field type={'text'} className="form-control" placeholder="National ID Number" name="nida_no"/>
                  </div>
                </div>
                <div className="col-md-4 col-sm-12">
                  <div className="mb-3">
                    <label htmlFor="pasport_no" className="form-label">Passport Number</label>
                    <Field type={'text'} className="form-control" placeholder="Passport Number" name="pasport_no"/>
                  </div>
                </div>

              </div>
            </div>
            <div className="d-flex align-items-start gap-3 mt-4">
              <button type="button" className="btn btn-light btn-label previestab" onClick={handlePrev}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
              <button type="submit" className="btn btn-success btn-label right ms-auto nexttab nexttab"><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Next</button>
            </div>
          </div>
        </Form>
      )}
      </Formik>
    </>
  )

}
